class GiftCardForm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.form = this.els.form.element

    this.updateFormData = this.updateFormData.bind(this)

    this.updateMessageCharLimit()
  }

  setupListeners () {
    super.setupListeners()

    this.els.submit.element.addEventListener('click', e => {
      e.preventDefault()

      if (this.els.submit.element.ariaDisabled === 'true') return

      if (this.form.checkValidity()) {
        this.updateFormData()
        this.externalEls.formButton.element.click()
      } else {
        this.form.reportValidity()
      }
    })

    this.els.message?.element?.addEventListener('input', () => {
      this.updateMessageCharLimit()
    })

    this.handleDateInput = this.handleDateInput.bind(this)

    this.dateEl = this.els.date.element

    if (this.dateEl) {
      this.dateEl.addEventListener('input', this.handleDateInput)
    }
  }

  updateFormData () {
    const formData = new FormData(this.form)
    for (const [key, value] of formData.entries()) {
      const input = this.externalEls.form.element.querySelector(
        `[name="${key}"]`,
      )
      if (input) {
        input.value = value
      }
    }
  }

  updateMessageCharLimit () {
    const messageEl = this.els.message?.element
    const limitTextEl = this.els['message-limit-text']?.element
    const limit = this.dataset.messageCharLimit || 200

    if (!messageEl || !limitTextEl) return

    let value = messageEl.value || ''

    if (value.length > limit) {
      value = value.slice(0, limit)
      messageEl.value = value
    }

    const remaining = limit - value.length

    limitTextEl.textContent = `${remaining}`
  }

  handleDateInput (e) {
    this.dateEl
      .closest('.frm-Form_Field')
      ?.classList.remove('frm-Form_Field-error')

    this.dateEl.classList.toggle(
      'drw-GiftCard_DateInput-bold',
      !!this.dateEl.value,
    )
  }
}

if (!customElements.get('gift-card-form')) {
  customElements.define('gift-card-form', GiftCardForm)
}
